export default class Pagination {
  page: number;

  sortBy: Array<string>;

  total: number;

  pageCount: number;

  itemsPerPage: number;

  sortDesc: Array<boolean>;

  defaultSort: string;

  constructor(obj: any = {}) {
    this.page = obj.page || 1;
    this.itemsPerPage = obj.itemsPerPage || 10;
    this.sortBy = obj.sortBy || [];
    this.pageCount = obj.pageCount || 0;
    this.total = obj.total || 0;
    this.sortDesc = obj.sortDesc || [false];
    this.defaultSort = obj.defaultSort || '';
  }

  get arrangeSortBy(): string {
    if (this.sortBy.length === 0) {
      return this.defaultSort;
    }
    return `${this.sortBy[0]}|${this.order}`;
  }

  get order() {
    if (this.sortDesc[0] === true) {
      return 'desc';
    }
    return 'asc';
  }

  verifyPage(): void {
    if (Math.ceil(this.total / this.itemsPerPage) <= this.page - 1) {
      this.page = 1;
    }
  }
}
